<template>
  <div>
    <h1 class="text-4xl font-extrabold pl-2 tracking-tight text-gray-900 my-4">
      {{ $t("Store") }}
    </h1>
    <div v-if="currentStore">
      <StoreSetup v-if="storeInSetup" :store="currentStore" @configurationUpdated="fetchStoreDetails" />
      <StoreActive v-else :store="currentStore" @reloadStore="fetchStore" />
    </div>
    <div v-else>
      <p>{{ $t("Loading...") }}</p>
    </div>
  </div>
</template>

<script>
import StoreActive from "@/components/store/details/StoreActive.vue";
import StoreSetup from "@/components/store/details/StoreSetup.vue";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    StoreActive,
    StoreSetup,
  },
  computed: {
    ...mapState("store", ["currentStore"]),
    ...mapGetters("store", ["isStoreSetup"]),
    storeInSetup() {
      return this.isStoreSetup(this.currentStore);
    },
  },
  async mounted() {
    await this.fetchStoreDetails();
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("auth", ["refreshCurrentUser"]),
    ...mapActions("store", { fetchStore: "fetch" }),

    async fetchStoreDetails() {
      await this.fetchStore({
        id: this.$route.params.id,
        includes: ["organization", "iban", "discount_store_relation.discount", "billing_entity"],
      });
    },
  },
  watch: {
    store(newStore, oldStore) {
      if (oldStore?.setupStatus === "information_to_be_completed" && newStore?.setupStatus === "pending_verification") {
        this.notify({
          category: "simple",
          type: "success",
          title: "Point de vente configuré !",
          text: "Merci d'avoir complété les informations de votre point de vente. Votre demande est en cours de vérification.",
        });
        this.refreshCurrentUser(); // update currentUser.storeToSetup (update Banner to setup store display)
      }
    },
  },
};
</script>
